import './radio-button.scss'

export const CustomRadioButton = ({ input, checked, label, ...props }) => {
  return (
    <label className="radio-label">
      <input
        {...input}
        type="radio"
        checked={checked}
        className="radio-input"
        {...props}
      />
      <span className="custom-radio"></span>
      {label}
    </label>
  )
}